<template>
  <div class="post_new_area">
    <div class="error_message">
      {{ errorMessageUser }}
    </div>
    <textarea v-model="content" placeholder="input comment"></textarea>
    <div class="error_message">
      {{ t(errorMessageContent) }}
    </div>
    <div class="image_list">
      <ImageSelect v-for="(image, index) in images" :image="image" :index="index" @handleFileChange="handleFileChange"
        @handleFileDelete="handleFileDelete" :key="index"></ImageSelect>
      <ImageSelect v-if="images.length < 3" :index="images.length" @handleFileChange="handleFileChange"></ImageSelect>
    </div>
    <div class="button_area">
      <SquareButton
        class="label-input nomt square-button"
        text="Back"
        @handleSquareBtnClick="goToBack"
      />
      <BlackGradationButton
        class="square-button"
        text="post"
        @handleSquareBtnClick="click"
      />
    </div>
    <CommonOverlay class="overlay" v-show="isOpenModal">
      <CommonModal class="modal">
        <div class="modal-title">
          <span>Completed</span>
        </div>
        <div class="text">
          <span>The posting to the bulletin board has been completed.</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="CLOSE"
            :isSub="true"
            @handleSquareBtnClick="isOpenModal = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </div>
</template>

<script>
import t from '@/plugins/i18n';
import ImageSelect from '@/components/atoms/ImageSelect.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ImageSelect,
    CommonOverlay,
    CommonModal,
    SquareButton,
    BlackGradationButton,
  },

  computed: {
    ...mapGetters({
      postResult: 'post/postResult',
    }),
  },

  data: () => ({
    images: [],
    content: '',
    errorMessageContent: null,
    errorMessageUser: null,
    isOpenModal: false,
  }),
  mixins: [t],

  watch: {
    postResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.isOpenModal = true;
          this.errorMessageContent = null;
          this.errorMessageUser = null;
          this.content = '';
          this.images.splice(0);
          this.$store.dispatch('post/clearPostResult');
        } else {
          const {
            content,
            user,
          } = newVal.errors;
          this.errorMessageContent = content ? content[0] : null;
          this.errorMessageUser = user ? user[0] : null;
        }
      }
    },
  },

  methods: {
    handleFileChange({ index, event }) {
      const { files } = event.target;
      if (files.length > 0) {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          this.images.splice(index, 1, readerEvent.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
    handleFileDelete({ index }) {
      if (window.confirm('delete this image?')) {
        this.images.splice(index, 1);
      }
    },
    click() {
      this.$emit('handleBtnClick', {
        content: this.content,
        images: this.images,
      });
    },
    goToBack() {
      this.$emit('handleBackBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.post_new_area {
  max-width: 600px;
  margin: 20px auto 0 auto;
  @include appendMap($backgroundStyleMap);

  .image_list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  textarea {
    width: 100%;
    margin-bottom: 10px;
    border: solid 1px $white;
    height: 260px !important;
    background-color: $white;
    padding: 5px;
  }

  input {
    width: 100%;
    color: $white;
    background-color: #f00;
  }

  .button_area {
    margin-top: 10px;
    text-align: right;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    div {
      min-width: 200px;
    }
  }
  .error_message {
    color: red;
  }
  .overlay {
    .modal {
      max-width: 530px;
      padding: 20px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .modal-title {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
      }
      .text {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
